module.exports = __webpack_public_path__ + "static/media/timothy-kelleher.586910d7.jpg";